import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServiceSliceState } from "../../types/store";
import { Family } from "../../types/families";
import { DEFAULT_TABLE_PAGINATION } from "../../constants/pagination";
import { TablePaginationConfig } from "../../types/common";

const initialState: ServiceSliceState = {
  familiesPaginatedData: [],
  familiesTablePaginationConfig: DEFAULT_TABLE_PAGINATION,
  familiesTotalNumberOfPages: 1,
}

export const SERVICE_SLICE_STATE = 'service' as const;

export const serviceSlice = createSlice({
  name: SERVICE_SLICE_STATE,
  initialState: initialState,
  reducers: {
    loadFamiliesPaginatedData: (
      state: ServiceSliceState,
      { payload: data }: PayloadAction<Family[]>
    ) => {
      state.familiesPaginatedData = data;
    },
    loadFamiliesTablePaginationConfig: (
      state: ServiceSliceState,
      { payload: paginationConfig }: PayloadAction<TablePaginationConfig> 
    ) => {
      state.familiesTablePaginationConfig = paginationConfig;
    },
    loadFamiliesTotalNumberOfPages: (
      state: ServiceSliceState,
      { payload: numberOfPages }: PayloadAction<number>
    ) => {
      state.familiesTotalNumberOfPages = numberOfPages;
    }
  }
});

export const {
  loadFamiliesPaginatedData,
  loadFamiliesTablePaginationConfig,
  loadFamiliesTotalNumberOfPages,
} = serviceSlice.actions;

export default serviceSlice.reducer;